export class EwayItemList {
    public item_number!: number;
    public product_id!: number;
    public product_name!: string;
    public product_description!: string;
    public hsn_code!: number;
    public quantity!: number;
    public unit_of_product!: string;
    public cgst_rate!: number;
    public sgst_rate!: number;
    public igst_rate!: number;
    public cess_rate!: number;
    public cessNonAdvol!: number;
    public taxable_amount!: number;
}